// extracted by mini-css-extract-plugin
export var header = "index-module--header--GkXlg";
export var avatar = "index-module--avatar--1TOdV";